module.exports = __webpack_public_path__ + "static/media/banner.2321f921.png";